import React from 'react';
import PropTypes from 'prop-types';
import useStyles from '@front10/helpers/dist/UseStyles';
import Box from '../../../elements/Box';
import FareItemDate from '../../../items/_commons/atoms/FareItemDate';

const MonthlyHistogramBar = ({
  monthItem,
  fareItem,
  data,
  tabIndex,
  tabIndexCallToAction,
  focusReferences,
  showMonthItem,
  ...props
}) => {
  const {
    monthFormat,
    fare,
    isLowest,
    FareComponentInstance,
    fareItemHeight,
    fareItemMaxHeight,
    showHistogramBar
  } = data;
  const [className] = useStyles(props);
  const effectiveFareItemHeight =
    typeof fareItemHeight === 'number' && fareItemHeight > 0 ? fareItemHeight : 0;
  const shouldRenderHistogramBar = showHistogramBar !== false && effectiveFareItemHeight > 0;
  const containerHeight = `${fareItemMaxHeight}px`;
  const containerPaddingTop = `${Math.max(
    fareItemMaxHeight - effectiveFareItemHeight,
    0
  )}px !important`;
  const fareComponentStyle = shouldRenderHistogramBar
    ? { height: `${effectiveFareItemHeight}px` }
    : {};
  return (
    <Box className={`fr-monthly-carousel ${className}`} width="100">
      <Box
        width="100"
        display="flex"
        flexDirection="column"
        style={{
          paddingTop: containerPaddingTop,
          height: containerHeight,
          justifyContent: 'flex-end'
        }}
      >
        <FareComponentInstance
          {...fareItem}
          data={fare}
          isLowest={isLowest}
          showDay={false}
          tabIndex={tabIndex}
          focusReferences={focusReferences}
          tabIndexCallToAction={tabIndexCallToAction}
          style={fareComponentStyle}
        />
      </Box>
      {showMonthItem && (
        <FareItemDate
          {...monthItem}
          ariaHidden
          date={fare.departureDate}
          monthFormat={monthFormat}
          showTwoLines={!!monthItem.showTwoLines}
        />
      )}
    </Box>
  );
};

MonthlyHistogramBar.propTypes = {
  showMonthItem: PropTypes.bool,
  monthItem: PropTypes.objectOf(PropTypes.any),
  fareItem: PropTypes.objectOf(PropTypes.any),
  data: PropTypes.objectOf(PropTypes.any),
  tabIndex: PropTypes.bool,
  tabIndexCallToAction: PropTypes.bool,
  focusReferences: PropTypes.func
};

MonthlyHistogramBar.defaultProps = {
  showMonthItem: true,
  monthItem: {},
  fareItem: {},
  data: {},
  tabIndex: false,
  tabIndexCallToAction: true,
  focusReferences: () => {}
};

export default MonthlyHistogramBar;
